import Vue from 'vue' 
import VueRouter from 'vue-router'
import INDEX from '../views/tabbar/index.vue'
import HOME from '../views/tabbar/home.vue'
import ZX from '../views/tabbar/zx.vue'
import SQ from '../views/tabbar/sq.vue'
import MSG from '../views/tabbar/msg.vue'
import MINE from '../views/tabbar/mine.vue'
import LOGIN from '../views/login/login.vue'
import ORDER_CONFIRM from '../views/orderConfirm/orderConfirm.vue'

import SEARCH from '../views/home/search/search.vue'
import LUNBPAGE from '../views/home/lunbPage/lunbPage.vue'
import TEACHER_LIST from '../views/home/teacher/list.vue'
import TEACHER_DETAILS from '../views/home/teacher/details.vue'
import TEACHER_TOP from '../views/zx/teacherTop/top.vue'

import KC_LIST from '../views/home/kc/list.vue'
import KC_DETAILS from '../views/home/kc/details.vue'

import WZ_LIST from '../views/home/wz/list.vue'
import WZ_DETAILS from '../views/home/wz/details.vue'
import WZ_C_LIST from '../views/home/wz/commentList.vue'


import SX from '../views/home/sx/list.vue'
import SX_DETAILS from '../views/home/sx/details.vue'

import XZ from '../views/home/xz/list.vue'
import XZ_DETAILS from '../views/home/xz/datails.vue'

import WX from '../views/home/wx/details.vue'
 
import CG from '../views/home/menu/cgsm/index.vue'
import CG_RES from '../views/home/menu/cgsm/result.vue'
import PK from '../views/home/menu/pkzb/index.vue'
import PK_RES from '../views/home/menu/pkzb/result.vue'
import SXSM from '../views/home/menu/sxsm/index.vue'
import SXSM_RES from '../views/home/menu/sxsm/result.vue'
import SMLS from '../views/home/menu/smls/index.vue'
import SMLS_RES from '../views/home/menu/smls/result.vue'
import XZPD from '../views/home/menu/xzpd/index.vue'
import XZPD_RES from '../views/home/menu/xzpd/result.vue'
import SXPD from '../views/home/menu/sxpd/index.vue'
import SXPD_RES from '../views/home/menu/sxpd/result.vue'
import XXPD from '../views/home/menu/xxpd/index.vue'
import XXPD_RES from '../views/home/menu/xxpd/result.vue'
import NUMJX from '../views/home/menu/numjx/index.vue'
import NUMJX_RES from '../views/home/menu/numjx/result.vue'
import ZWJX from '../views/home/menu/zwjx/index.vue'
import ZWJX_RES from '../views/home/menu/zwjx/result.vue'
import YTJX from '../views/home/menu/ytjx/index.vue'
import YTJX_RES from '../views/home/menu/ytjx/result.vue'
import ZGJM from '../views/home/menu/zgjm/index.vue'
import ZGJM_SEARCH_RES from '../views/home/menu/zgjm/searchRes.vue'
import ZGJM_DETAILS from '../views/home/menu/zgjm/details.vue'
import CALENDAR from '../views/home/calendar/calendar.vue'

import RECHARGE from '../views/mine/recharge/recharge.vue'
import MINE_FB from '../views/mine/release/release.vue'

import ORDER_ZX from '../views/mine/order/consult.vue'
import ORDER_AW from '../views/mine/order/aw.vue'
import AW_RES from '../views/mine/order/awDeatils.vue'
import KC_ORDER from '../views/mine/order/kcOrder.vue'
import EDIT_USET from '../views/mine/editUserInfo/editUserInfo.vue'
import RECRUIT from '../views/mine/recruit/recruit.vue'
import AGREEMENT from '../views/mine/agreement/agreement.vue'
import TXT from '../views/mine/agreement/txt.vue'
import FEEDBACK from '../views/mine/feedback/feedback.vue'
import COUPON from '../views/mine/coupon/coupon.vue'
import COLLECTION from '../views/mine/collection/collection.vue'
import FOCUS from '../views/mine/focus/focus.vue'
import USERPAGE from '../views/mine/focus/userpage.vue'



import MY_TW from '../views/zx/tw/ask.vue'
import SELECT_TEACHER from '../views/zx/tw/selectTeacher.vue'
import SIGN from '../views/sign/sign.vue'

import EDIT from '../views/sq/edit.vue'
import TIEDETAILS from '../views/sq/tieDetail.vue'
import CHAT from '../views/msg/chat.vue'
import SERVECHAT from '../views/msg/serveChat.vue'
import EVALUATE from '../views/mine/order/evaluate.vue'
import MSGPAGE from '../views/msg/msg.vue'



// 老师
import TEACHER_MINE from '../views/teacher/mine/mine.vue'
import TEACHER_MINE_DETAIL from '../views/teacher/mine/mineDetail.vue'
import CASH_OUT from '../views/teacher/cashOut/cashOut.vue'
import COMMISSION_DETAILS from '../views/teacher/cashOut/commissionDetails.vue'
import SPREAD from '../views/teacher/spread/spread.vue'
import COMMENTS_RECEIVED from '../views/teacher/commentsReceived/commentsReceived.vue'
import PHRASE from '../views/teacher/phrase/phrase.vue'
import wd_order from '../views/teacher/order/wdorder.vue'
import ZXORDER from '../views/teacher/order/zxOrder.vue'
import awQuestion from '../views/teacher/order/awQuestion.vue'
import KC from '../views/teacher/order/kc.vue'
import YJ from '../views/teacher/yjList/yjList.vue'
import YJDETAIL from '../views/teacher/yjDeatil/yjDeatil.vue'
import GETWORK from '../views/teacher/getWork/getWork.vue'


Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: INDEX,

    meta: {
      title: "炎麟文化,四柱命理,生辰八字,在线算命，算卦占卜一对一咨询",
      content: "炎麟文化,四柱命理,生辰八字,在线算命，算卦占卜一对一咨询"
    },
    redirect: "/home",
    children: [
      {
        path: '/home',
        name: 'home',
        component: HOME,
        meta: {
          title: "炎麟文化,四柱命理,生辰八字,在线算命，算卦占卜一对一咨询",
          content: "炎麟文化,四柱命理,生辰八字,在线算命，算卦占卜一对一咨询"
        }
      },
      {
        path: '/zx',
        name: 'zx',
        component: ZX,
        meta: {
          title: "咨询",
          content: "咨询"
        }
      },
      {
        path: '/sq',
        name: 'sq',
        component: SQ,
        meta: {
          title: "社区",
          content: "社区"
        }
      },
      {
        path: '/msg',
        name: 'msg',
        component: MSG,
        meta: {
          title: "消息",
          content: "消息",
          mustLogin: true
        }
      },
      {
        path: '/msgpage',
        name: 'msgpage',
        component: MSGPAGE,
        meta: {
          title: "免责声明，炎麟文化",
          content: "免责声明，炎麟文化",
          mustLogin: true
        }
      },
      {
        path: '/mine',
        name: 'mine',
        component: MINE,
        meta: {
          title: "我的",
          content: "我的"
        }
      },
      {
        path: '/tmine',
        name: 'tmine',
        component: TEACHER_MINE,
        meta: {
          title: "个人中心",
          content: "个人中心"
        }
      }
    ]
  },
  {
    path: "/login",
    name: "login",
    component: LOGIN,
    meta: {
      title: "登录",
      content: "登录"
    },
  },
  {
    path: "/mineDetail",
    name: "mineDetail",
    component: TEACHER_MINE_DETAIL,
    meta: {
      title: "个人中心",
      content: "个人中心"
    },
  },
  {
    path:'/postDetails',
    name:'postDetails',
    component: TIEDETAILS,
    meta: {
      title: "帖子详情",
      content: "帖子详情"
    },
  },
  {
    path: "/getWork",
    name: "getWork",
    component: GETWORK,
    meta: {
      title: "抢单大厅",
      content: "抢单大厅"
    },
  },
  {
    path: "/search",
    name: "search",
    component: SEARCH,
    meta: {
      title: "搜索",
      content: "搜索"
    },
  },
  {
    path: "/lunbpage",
    name: "lunbpage",
    component: LUNBPAGE,
    meta: {
      title: "资讯",
      content: "资讯"
    },
  },
  {
    path: "/teacherList",
    name: "teacherList",
    component: TEACHER_LIST,
    meta: {
      title: "老师",
      content: "老师"
    },
  },
  {
    path: "/teacherTop",
    name: "teacherTop",
    component: TEACHER_TOP,
    meta: {
      title: "老师",
      content: "老师"
    },
  },
  {
    path: "/yj",
    name: "yj",
    component: YJ,
    meta: {
      title: "收益",
      content: "收益"
    },
  },

  {
    path:'/yjdeatil',
    name: "yjdetail",
    component: YJDETAIL,
    meta: {
      title: "费用详细",
      content: "费用详细"
    },
  },
  {
    path: "/teacherDetails",
    name: "teacherDetails",
    component: TEACHER_DETAILS,
    meta: {
      title: "详情",
      content: "详情"
    },
  },
  
  {
    path: "/sign",
    name: "sign",
    component: SIGN,
    meta: {
      title: "签到",
      content: "签到"
    },
  },
  {
    path: "/kclist",
    name: "kclist",
    component: KC_LIST,
    meta: {
      title: "课程",
      content: "课程"
    },
  },
  {
    path: "/tkc",
    name: "tkc",
    component: KC,
    meta: {
      title: "课程",
      content: "课程"
    },
  },
  {
    path: "/wzlist",
    name: "wzlist",
    component: WZ_LIST,
    meta: {
      title: "文章",
      content: "文章",
      keepAlive: true
    },
  },
  {
    path: "/kcdetails",
    name: "kcdetails",
    component: KC_DETAILS,
    meta: {
      title: "课程",
      content: "课程"
    },
  },
  {
    path: "/wzdetails",
    name: "wzdetails",
    component: WZ_DETAILS,
    meta: {
      title: "文章",
      content: "文章"
    },
  },
  {
    path: "/wzcdetails",
    name: "wzcdetails",
    component: WZ_C_LIST,
    meta: {
      title: "全部评论",
      content: "全部评论"
    },
  },
  {
    path: "/ask",
    name: "ask",
    component: MY_TW,
    meta: {
      title: "我要提问",
      content: "我要提问",
      mustLogin: true
    },
  },
  {
    path: "/st",
    name: "st",
    component: SELECT_TEACHER,
    meta: {
      title: "选择老师",
      content: "选择老师"
    },
  },
  {
    path: "/sx",
    name: "sx",
    component: SX,
    meta: {
      title: "生肖，炎麟文化",
      content: "生肖"
    }
  },
  {
    path: '/sxdetails',
    name: 'sxdetails',
    component: SX_DETAILS,
    meta: {
      title: "生肖详情，炎麟文化",
      content: "生肖详情"
    }
  },
  {
    path: '/xz',
    name: 'xz',
    component: XZ,
    meta: {
      title: "星座，炎麟文化",
      content: "星座"
    }
  },
  {
    path: '/xzdetails',
    name: 'xzdetails',
    component: XZ_DETAILS,
    meta: {
      title: "星座详情，炎麟文化",
      content: "星座详情"
    }
  },
  {
    path: '/wx',
    name: 'wx',
    component: WX,
    meta: {
      title: "五行分析，炎麟文化",
      content: "五行分析"
    }
  },
  {
    path: '/cg',
    name: 'cg',
    component: CG,
    meta: {
      title: "称骨算命，炎麟文化",
      content: "称骨算命"
    }
  },
  {
    path: '/cgres',
    name: 'cgres',
    component: CG_RES,
    meta: {
      title: "称骨算命，炎麟文化",
      content: "称骨算命"
    }
  },
  {
    path: '/pk',
    name: 'pk',
    component: PK,
    meta: {
      title: "扑克占卜，炎麟文化",
      content: "扑克占卜"
    }
  },
  {
    path: '/calendar',
    name: 'calendar',
    component: CALENDAR,
    meta: {
      title: "日历，炎麟文化",
      content: "日历"
    }
  },
  {
    path: '/pkres',
    name: 'pkres',
    component: PK_RES,
    meta: {
      title: "扑克占卜，炎麟文化",
      content: "扑克占卜"
    }
  },
  {
    path: '/sxsm',
    name: 'sxsm',
    component: SXSM,
    meta: {
      title: "生肖算命，炎麟文化",
      content: "生肖算命"
    }
  },
  {
    path: '/sxsmres',
    name: 'sxsmres',
    component: SXSM_RES,
    meta: {
      title: "生肖算命，炎麟文化",
      content: "生肖算命"
    }
  },
  {
    path: '/smls',
    name: 'smls',
    component: SMLS,
    meta: {
      title: "生命灵数，炎麟文化",
      content: "生命灵数"
    }
  },
  {
    path: '/smlsres',
    name: 'smlsres',
    component: SMLS_RES,
    meta: {
      title: "生命灵数，炎麟文化",
      content: "生命灵数"
    }
  },
  {
    path: '/sxpd',
    name: 'sxpd',
    component: SXPD,
    meta: {
      title: "生肖配对，炎麟文化",
      content: "生肖配对"
    }
  },
  {
    path: '/sxpdres',
    name: 'sxpdres',
    component: SXPD_RES,
    meta: {
      title: "生肖配对，炎麟文化",
      content: "生肖配对"
    }
  },
  {
    path: '/xzpd',
    name: 'xzpd',
    component: XZPD,
    meta: {
      title: "星座配对，炎麟文化",
      content: "星座配对"
    }
  },
  {
    path: '/xzpdres',
    name: 'xzpdres',
    component: XZPD_RES,
    meta: {
      title: "星座配对，炎麟文化",
      content: "星座配对"
    }
  },
  {
    path: '/xxpd',
    name: 'xxpd',
    component: XXPD,
    meta: {
      title: "血型配对，炎麟文化",
      content: "血型配对"
    }
  },
  {
    path: '/xxpdres',
    name: 'xxpdres',
    component: XXPD_RES,
    meta: {
      title: "血型配对，炎麟文化",
      content: "血型配对"
    }
  },
  {
    path: '/numjx',
    name: 'numjx',
    component: NUMJX,
    meta: {
      title: "手机号码，炎麟文化",
      content: "手机号码"
    }
  },
  {
    path: '/numjxres',
    name: 'numjxres',
    component: NUMJX_RES,
    meta: {
      title: "手机号码，炎麟文化",
      content: "手机号码"
    }
  },
  {
    path: '/zwjx',
    name: 'zwjx',
    component: ZWJX,
    meta: {
      title: "指纹吉凶，炎麟文化",
      content: "指纹吉凶"
    }
  },
  {
    path: '/zwjxres',
    name: 'zwjxres',
    component: ZWJX_RES,
    meta: {
      title: "指纹吉凶，炎麟文化",
      content: "指纹吉凶"
    }
  },
  {
    path: '/ytjx',
    name: 'ytjx',
    component: YTJX,
    meta: {
      title: "眼跳吉凶，炎麟文化",
      content: "眼跳吉凶"
    }
  },
  {
    path: '/ytjxres',
    name: 'ytjxres',
    component: YTJX_RES,
    meta: {
      title: "眼跳吉凶，炎麟文化",
      content: "眼跳吉凶"
    }
  },
  {
    path: '/zgjm',
    name: 'zgjm',
    component: ZGJM,
    meta: {
      title: "周公解梦，炎麟文化",
      content: "周公解梦"
    }
  },
  {
    path: '/zgjmsearch',
    name: 'zgjmsearch',
    component: ZGJM_SEARCH_RES,
    meta: {
      title: "周公解梦，炎麟文化",
      content: "周公解梦"
    }
  },
  {
    path: '/jmdetails',
    name: 'jmdetails',
    component: ZGJM_DETAILS,
    meta: {
      title: "周公解梦，炎麟文化",
      content: "周公解梦"
    }
  },
  {
    path: '/recharge',
    name: 'recharge',
    component: RECHARGE,
    meta: {
      title: "充值金币，炎麟文化",
      content: "充值金币"
    }
  },
  {
    path: '/fb',
    name: 'fb',
    component: EDIT,
    meta: {
      title: "我的发布，炎麟文化",
      content: "我的发布"
    }
  },
  {
    path: '/minefb',
    name: 'minefb',
    component: MINE_FB,
    meta: {
      title: "我的发布",
      content: "我的发布"
    }
  },
  {
    path: '/collection',
    name: 'collection',
    component: COLLECTION,
    meta: {
      title: "我的收藏",
      content: "我的收藏"
    }
  },
  {
    path: '/focus',
    name: 'focus',
    component: FOCUS,
    meta: {
      title: "我的关注",
      content: "我的关注"
    }
  },
  {
    path: '/userpage',
    name: 'userpage',
    component: USERPAGE,
    meta: {
      title: "个人主页",
      content: "个人主页"
    }
  },
  {
    path: '/chat',
    name: 'chat',
    component: CHAT,
    meta: {
      title: "聊天v1.9",
      content: "聊天v1.9"
    }
  },
  {
    path: '/serveChat',
    name: 'serveChat',
    component: SERVECHAT,
    meta: {
      title: "聊天v1.9",
      content: "聊天v1.9"
    }
  },
  {
    path: '/orderzx',
    name: 'orderzx',
    component: ORDER_ZX,
    meta: {
      title: "咨询订单",
      content: "咨询订单"
    }
  },
  {
    path: '/evaluate',
    name: 'evaluate',
    component: EVALUATE,
    meta: {
      title: "评价",
      content: "评价"
    }
  },
  {
    path: '/orderaw',
    name: 'orderaw',
    component: ORDER_AW,
    meta: {
      title: "问答订单",
      content: "问答订单"
    }
  },
  {
    path: '/awres',
    name: 'awres',
    component: AW_RES,
    meta: {
      title: "问答订单",
      content: "问答订单"
    }
  },
  {
    path: '/kcOrder',
    name: 'kcOrder',
    component: KC_ORDER,
    meta: {
      title: "课程订单",
      content: "课程订单"
    }
  },
  {
    path: '/chshout',
    name: 'chshout',
    component: CASH_OUT,
    meta: {
      title: "提现",
      content: "提现"
    }
  },
  {
    path: '/commissionDetails',
    name: 'commissionDetails',
    component: COMMISSION_DETAILS,
    meta: {
      title: "费用详细",
      content: "费用详细"
    }
  },
  {
    path: '/spread',
    name: 'spread',
    component: SPREAD,
    meta: {
      title: "推广",
      content: "推广"
    }
  },
  {
    path: '/commentsReceived',
    name: 'commentsReceived',
    component: COMMENTS_RECEIVED,
    meta: {
      title: "我收到的评价",
      content: "我收到的评价"
    }
  },
  {
    path: '/phrase',
    name: 'phrase',
    component: PHRASE,
    meta: {
      title: "自定义快捷短语",
      content: "自定义快捷短语"
    }
  },
  {
    path: '/twdorder',
    name: 'twdorder',
    component: wd_order,
    meta: {
      title: "问答订单",
      content: "问答订单"
    }
  },
  {
    path: '/zxorder',
    name: 'zxorder',
    component: ZXORDER,
    meta: {
      title: "咨询订单",
      content: "咨询订单"
    }
  },
  {
    path: '/awQuestion',
    name: 'awQuestion',
    component: awQuestion,
    meta: {
      title: "问答详情",
      content: "问答详情"
    }
  },
  {
    path: '/editUser',
    name: 'editUser',
    component: EDIT_USET,
    meta: {
      title: "完善资料",
      content: "完善资料",
      mustLogin: true
    }
  },
  {
    path: '/recruit',
    name: 'recruit',
    component: RECRUIT,
    meta: {
      title: "老师招募 ",
      content: "老师招募 "
    }
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: AGREEMENT,
    meta: {
      title: "用户协议",
      content: "用户协议"
    }
  },
  {
    path: '/txt',
    name: 'txt',
    component: TXT,
    meta: {
      title: "分享赚钱",
      content: "分享赚钱"
    }
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: FEEDBACK,
    meta: {
      title: "投诉反馈",
      content: "投诉反馈"
    }
  },
  {
    path: '/coupon',
    name: 'coupon',
    component: COUPON,
    meta: {
      title: "优惠券",
      content: "优惠券"
    }
  },
  {
    path: '/orderConfirm',
    name: 'orderConfirm',
    component: ORDER_CONFIRM,
    meta: {
      title: "确认订单",
      content: "确认订单"
    }
  },

]

const router = new VueRouter({
  mode: 'history',
  base: '/h5/',
  routes:routes,

  scrollBehavior(to, from, saveTop) {
    if (saveTop) {
      return saveTop;
    } else {
      return { x: 0, y: 0 }
    }
  }
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }

  const TOKEN = localStorage.getItem("token");
  const user = JSON.parse(localStorage.getItem("user"));

  if (to.meta && to.meta.mustLogin && !TOKEN) {
    next({ path: '/login' })
  } else {
    if (to.name === "mine" && TOKEN && user.is_teacher == 1) {
      next({ path: '/tmine' })
    } else {
      next()
    }
  }

})



export default router
